module.exports = __webpack_public_path__ + "static/media/backgroundMedium.d2756fa6.jpg";